import { Vector3 } from "three";

// Fixed pool of impact-flash slots, mirroring collision.ts's module-level
// blade registry. A pointLight per hit that mounts/unmounts with the hit's
// <Block> would change the scene's live point-light count on every cut —
// three.js bakes that count into a shader #define (NUM_POINT_LIGHTS), so any
// change forces a synchronous recompile of every lit material in the scene
// (see .extras "freeze then jump" perf fix, 2026-07-10). A fixed number of
// always-mounted lights (HitFlashPool.tsx), driven by these plain-object
// slots, keeps that count constant for the whole session.
export interface HitFlashSlot {
  position: Vector3;
  color: string;
  intensity: number;
}

const POOL_SIZE = 4;

export const hitFlashSlots: HitFlashSlot[] = Array.from(
  { length: POOL_SIZE },
  () => ({
    position: new Vector3(),
    color: "#ffffff",
    intensity: 0,
  }),
);

let nextSlot = 0;

// Returns the slot so the caller can animate `intensity` (e.g. via GSAP)
// directly on it — HitFlashPool.tsx copies these values onto the real
// mounted lights every frame, so the caller never touches a light directly.
export function triggerHitFlash(position: Vector3, color: string): HitFlashSlot {
  const slot = hitFlashSlots[nextSlot];
  nextSlot = (nextSlot + 1) % POOL_SIZE;
  slot.position.copy(position);
  slot.color = color;
  return slot;
}
